import { Component, Injector, ViewChild, ViewContainerRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UiEngineComponent } from 'src/modules/base/components/ui-engine/ui-engine.component';
import { BsModalService } from 'ngx-bootstrap/modal';
import { LoaderService } from 'src/modules/base/services/loader.service';
import BaseDecorator from 'src/modules/base/base-decorator';
import { DialogModalSize } from 'src/modules/base/components/dialog/dialog-ref';
import { AsideBarService } from 'src/modules/base/services/asideBar.service';
import { CompositeArrayComponent } from 'src/modules/base/components/composite-array/composite-array.component';
import { FormGroup, Validators, FormBuilder, FormArray, AbstractControl, FormControl } from '@angular/forms';
import { BillingpopupComponent } from 'src/modules/billing/components/billingpopup/billingpopup.component';
// import { number } from 'cypress/e2e/services/login/login.service';

@Component({
    selector: 'app-insurance-billing',
    templateUrl: './insurance-billing.component.html',
    styleUrls: ['./insurance-billing.component.scss'],
    standalone: false
})
export class InsuranceBillingComponent extends UiEngineComponent {
  mySubscription: any;
  tabChange: boolean = false;
  scheme_id: any;
  @ViewChild('multiselectscheme') multiselectscheme: any;
  ip_banner: any;
  bill_details: any;
  disbledTimePickerRange:any ={};
  file_arg: any;
  actTab: any;
  comp_patient_res:any;
  dec_p:any;
  tabClick: boolean = false;
  ref_data:any
  gridSummary: boolean = false;
  @ViewChild('customComponent', { read: ViewContainerRef }) customComponent: ViewContainerRef;
  @ViewChild('compositeArrayComponent') compositeArrayComponent: CompositeArrayComponent;
  showPopUp: boolean = true;
  sidebarOpen: any;
  locale = {
    "format": "DD/MM/YYYY HH:mm"
  }
  from: any;
  to: any;
  currentData: any;
  refund_receiver_name: string;
  patientInfo: any;
  insuranceForm: FormGroup;
  total_service_amount: any;
  insurance: any;
  bill_date_time: string;
  discharge_date_time: string;
  admission_date_time: string;
  schemeresource: any;
  rec_no: string;
  bill_no: string;
  encounter_id: string;
  p_res:any;

  constructor(
    public injector: Injector,
    public router: Router,
    public route: ActivatedRoute,
    public loaderService: LoaderService,
    public modal: BsModalService,
    public asideBarService: AsideBarService,
    public formBuilder: FormBuilder
  ) {
    super(injector, router, route, modal)
    this.communicationService.emitSidebar({ sidebar: false });
    // this.router.events.subscribe((e: any) => {
    //   if (e instanceof NavigationEnd) {
    //     this.ngOnInit();
    //   }
    // });
    this.insuranceForm = new FormGroup({
      'rec_no': new FormControl(),
      "diagnosis": new FormControl([]),
      'bill_no': new FormControl(),
      'encounter_id': new FormControl(),
      'discharge_date_time': new FormControl(),
      'admission_date_time': new FormControl(),
      'bill_date_time': new FormControl(),
      'bill_details':  new FormControl([]),
      'bill_documents': new FormControl([]),
      'payment_detail': new FormControl([])
    })
  }

  ngOnInit() {
    // if(sessionStorage.getItem('currentData')!=undefined && sessionStorage.getItem('currentData')){
    //   let uniqueKeys = ["uhId","id"];
    //   this.storageService.setTabId(sessionStorage.getItem('currentData'),uniqueKeys);
    // }
    this.dec_p=this.baseService.initDecorator("InsuranceMiscServiceDecorator", this.route, this.injector);
    if (this.authenticationService && this.authenticationService.getUserType() == "patient") 
      {   
        this.comp_patient_res ="insurance_billing_item_m_patient"
          // let uhid = localStorage.getItem('hasUhId');
          // this.formService.baseService.get('GET_PAGE', 'uhId:'+uhid, 'referral_request_approval', 'insurance','uhId:'+uhid).subscribe(
          //   result => {
          //     if (result.errCode == 0 && result.resource.length > 0) 
          //     {
          //       this.ref_data=result.resource[0];
          //       this.insuranceForm.controls.rec_no.setValue(this.ref_data.rec_no);
          //     }
          //     else
          //     {
          //       this.formService.alerts.error("No Referral approval exists for this Patient.");
          //     }

          //   })
          // this.formService.baseService.get('GET_PATIENT_BY_UHID', 'uhId:'+uhid, 'patient', 'patient-registration').subscribe(
          //     result => {
          //         if (result.errCode == 0 && result.resource.length > 0) {
          //           this.p_res = result.resource[0];
          //         }
          //     }); 

      }
      else{
        this.comp_patient_res = "insurance_billing_item_miscllaneous_service_item";
      }
    super.ngOnInit();
    if (sessionStorage.currentData) {
      this.patientInfo = JSON.parse(sessionStorage.currentData);
      this.patientInfo
    }
    if(this.patientInfo){
      this.insuranceForm.controls.rec_no.setValue(this.patientInfo.rec_no);
    }
    var currentDateTime = new Date().getTime();
    this.insuranceForm.controls['bill_date_time'].setValue(currentDateTime);
    // this.insuranceForm.controls['bill_date_time'].value = currentDateTime;
    this.schemeresource = {
      "datasource": {
        "application": "emr",
        "resource": "diagnosis_classification",
        "query_id": "GET_CLASSIFICATION_DATA",
        "args": "type:Diagnosis"
      },
      format: "(item) => `${item.code} | ${item.code_description}`",

      question: {
        format: "(item) => `${item.code} | ${item.code_description}`",
        defaultsetting: {
          "singleSelection": false,
          "checkBoxRequired": true,
          "apliCall": true
        },
        "req_keys": [
          "code",
          "code_description"
        ],
        getterKey: 'code',
        getterValue: 'code_description',
        key: "id"
      },
      defaultsetting: {
        "singleSelection": false,
        "checkBoxRequired": true,
        "apliCall": true,
        "advancesearch": {
            "resource": "diagnosis_classification",
            "datasource": {
                "application": "emr",
                "query_id": "GET_DIAGNOSIS_ADVANCED_SEARCH_DATA",
                "args": "type:Diagnosis"
              }
            }
      },
    }
  }

  ngAfterViewInit() {
    this.checkSidebarOpen();
  }
  // selectDiagnosis(e, i, form) {
  //   let arr = [];
  //   if (this.insuranceForm.controls['diagnosis'].value != null)
  //     arr = [...this.insuranceForm.controls['diagnosis'].value, ...[e.alldata]]
  //   else {
  //     arr.push(e.alldata);
  //   }
  //   this.insuranceForm.controls['diagnosis'].setValue(arr);
  // }

  // removeDiagnosis(e, i, form) {
  //   form.diagnosis_array.setValue(e);
  // }
  OnServiceAdd(e) { 
    if(e && e.items[0] && e.items[0].folder_name != undefined) {
      this.insuranceForm.controls['bill_documents']=e.items;
    }
    else if(e && e.items[0] && e.items[0].received_amount != undefined) {
      this.insuranceForm.controls['payment_detail']=e.items;
    }
    else {
      for (let i = 0; i < e.items.length - 1; i++) {
        let element = e.items[i];
        if(element['serviceType_code'] == "pharmacy" || element['serviceType_code'] == "op_consultation"){
          if (element['serviceType_code'] == e.items[e.items.length - 1].serviceType_code) {
            this.compositeArrayComponent.removeRow(e.items.length - 1);
            this.formService.alerts.error("Duplicate values not allowed.");
            return;
          }
        }
        else{
          if (element['service_item_id'] == e.items[e.items.length - 1].service_item_id && (element['serviceType_code'] == e.items[e.items.length - 1].serviceType_code)) {
            this.compositeArrayComponent.removeRow(e.items.length - 1);
            this.formService.alerts.error("Duplicate values not allowed.");
            return;
          }
        }
      };
      this.insuranceForm.controls['bill_details']=e.items;
      this.total_service_amount = 0
      e.items.forEach(element => {
        if(element.amount != undefined){
            this.total_service_amount = Number(this.total_service_amount)+Number(element.amount)
            this.total_service_amount
        }
      });
    }    
  }
  onSponsorRemove(e){
    e.itemss.forEach(element => {
      if(element.amount != undefined){
          this.total_service_amount = Number(this.total_service_amount)-Number(element.amount)
          this.total_service_amount
      }
    });
  }
  onSubmit(event, e){
    if (this.insuranceForm.controls.bill_details && !this.insuranceForm.controls.bill_details[0] ) {
      this.alerts.error("Please Add Atleast one service")
      return
    }
    else{
        if(this.insuranceForm && this.insuranceForm.controls && this.insuranceForm.controls.bill_details && this.insuranceForm.controls.bill_details[0] == undefined){
          this.insuranceForm.controls.bill_details = this.insuranceForm.controls.bill_details.value;
        }
        if(this.insuranceForm && this.insuranceForm.controls && this.insuranceForm.controls.bill_documents && this.insuranceForm.controls.bill_documents[0] == undefined){
          this.insuranceForm.controls.bill_documents = this.insuranceForm.controls.bill_documents.value;
        }
        if(this.insuranceForm && this.insuranceForm.controls && this.insuranceForm.controls.payment_detail && this.insuranceForm.controls.payment_detail[0] == undefined){
          this.insuranceForm.controls.payment_detail = this.insuranceForm.controls.payment_detail.value;
        }
        if(this.insuranceForm && this.insuranceForm.controls && this.insuranceForm.controls.diagnosis && this.insuranceForm.controls.diagnosis[0] == undefined){
          this.insuranceForm.controls.diagnosis = this.insuranceForm.controls.diagnosis.value;
        }
        let insurance_request = {
         // "facility_id": this.patientInfo ? this.patientInfo.facility_id : this.ref_data ? this.ref_data.facility_id : "",
          "uhId" : this.patientInfo ? this.patientInfo.uhId : this.p_res.uhId,
          "bill_details": this.insuranceForm.controls.bill_details,
          "bill_documents": this.insuranceForm.controls.bill_documents,
          "diagnosis": this.insuranceForm.controls.diagnosis,
          "payment_detail": this.insuranceForm.controls.payment_detail,
          "encounter_id" : this.insuranceForm.controls.encounter_id.value ? this.insuranceForm.controls.encounter_id.value: '',
          "rec_no": this.insuranceForm.controls.rec_no.value ? this.insuranceForm.controls.rec_no.value: '',
          "bill_no": this.insuranceForm.controls.bill_no.value ? this.insuranceForm.controls.bill_no.value: '',
          "id": this.patientInfo ? this.patientInfo.id : this.ref_data.id,
          "admission_date_time": this.insuranceForm.controls.admission_date_time.value ? this.insuranceForm.controls.admission_date_time.value: '',
          "discharge_date_time": this.insuranceForm.controls.discharge_date_time.value ? this.insuranceForm.controls.discharge_date_time.value: '',
          "bill_date_time": this.insuranceForm.controls.bill_date_time.value ? this.insuranceForm.controls.bill_date_time.value: '',
          "total_service_amount": this.total_service_amount,
          "stage": "Bill Submitted",
          "status": "Request Claim Approval Pending"
        }
        this.baseService.action(insurance_request, 'Bill Update', 'insurance', 'referral_request_approval').subscribe((data) => {
          if (data.errCode == 0) {
              this.formService.alerts.success("Request Successful");
              this.formService.baseService.router.navigateByUrl(this.route.snapshot.queryParams.returnUrl);
          }
          else {
              this.formService.alerts.error(data.message)
          }
      })
    }
}
    refreshGridBanner(event) {
      if (!this.tabClick) {
        this.refreshBanner();
      }
      else {
        if (this._currentData.resource == 'billing_package_details' && event.button == 'ADD' && !this.tabClick) {
          this._layout_id = 'billingSummary';
          this.resourcename = 'billing_upload';
          super.ngOnInit();
        }
      }
  
      this.tabClick = false;
    }
  getBannerData(event) {
    this.ip_banner = event;
    this._currentData.bannerJson.key = event;
    this._currentData.bannerJson.existing_data = event;
    let diagnosispusharray = [];
    let diagnosis
    if(this.patientInfo && this.patientInfo.diagnosis && this.patientInfo.diagnosis[0]){
      this.patientInfo.diagnosis.forEach((element, index) => {
        diagnosis ={
          "code" : element.id,
          "code_description": element.text
        }
        if(this.multiselectscheme){
          this.multiselectscheme.setMultiselect(diagnosis);
        }
      })
    }
  }
  selectDiagnosis(event){}
  removeDiagnosis(event){}
  bannerLinks(e){
    if (e.event.event.action != "viewNoteBanner") {
      this.loaderService.showSpinner();
      this.formService.baseService.getById(this.patientInfo.payer_referral_id, 'payer', 'facility-management').subscribe(res => {
        if (res.errCode != -1) {
            let data = {
                // ui_resource: 'refer_master',
                args: "id:" + res.id,
                resource: 'payer',
                action: 'view',
                query_id: 'GET_BY_ID',
                application: 'facility-management'
  
            }
            this.formService.baseService.modalService.dialogService.open(BillingpopupComponent, { size: DialogModalSize.Lg, data }).afterClosed.subscribe(data => { }, err => { })
        }
        else{
          this.alerts.error("Payer is not mapped with referral name")
          this.loaderService.hideSpinner();
        }
    });
    }
  }
  layoutRenderer(resouceDef) {
    // written for emr specific - todo need to remove this
    if (this.route.snapshot.params.hasOwnProperty('action') && this.route.snapshot.params.action == "view") {
      resouceDef.layout.forEach(tab => {
        if (tab.action != "TAB")
          tab['action'] = 'LIST';
        this._currentData.addAllowed == false;
      });
    }
    this._layout_data = {};
    // this.activeTab(resouceDef.layout[0].id);
    this._currentData.tabType = resouceDef.tab_type;
    if (resouceDef.config != undefined && resouceDef.config.list_back_navigation != undefined)
      this._currentData.list_back_navigation = resouceDef.config.list_back_navigation;
    // if (this._currentData.tabType == 'vertical') {
    //   this.communicationService.emitSidebar({ sidebar: false });
    //   this.communicationService.emitChange({ hideMenuIcon: true });
    // }
    this._currentData.tabName = resouceDef.default_layout_id;
    if (resouceDef.default_layout_id != undefined && resouceDef.default_layout_id) {
      this._layout_id = resouceDef.default_layout_id;
    }
    if (resouceDef.banner && resouceDef.banner != undefined) {
      this._currentData.bannerJson = resouceDef.banner;
      // if (this.route && this.route.snapshot && this.route.snapshot.queryParams && this.route.snapshot.queryParams.returnUrl && (this.route.snapshot.queryParams.returnUrl.includes("patientlist_format") || this.route.snapshot.queryParams.returnUrl.includes("ip_bed_format") || this.route.snapshot.queryParams.returnUrl.includes("dc_bed_format") || this.route.snapshot.queryParams.returnUrl.includes("bed_format"))) {
      //   let cardData = JSON.parse(sessionStorage.getItem('currentData'));
      //   if (cardData && !this.route.snapshot.queryParams.returnUrl.includes("ip_bed_format") && !this.route.snapshot.queryParams.returnUrl.includes("dc_bed_format") && !this.route.snapshot.queryParams.returnUrl.includes("bed_format")) {
      //     this._currentData.bannerJson.datasource = {
      //       "application": "billing",
      //       "resource": "billing_details",
      //       "args": "uhId:" + cardData.uhId + ",admissionId:" + (cardData.encounter_id ? cardData.encounter_id : cardData.admissionId),
      //       "query_id": "GET_BY_ADMISSION_ID"
      //     }
      //   }
      //   else {
      //     let bedData = JSON.parse(sessionStorage.getItem('bedManagementData'));
      //     this._currentData.bannerJson.datasource = {
      //       "application": "billing",
      //       "resource": "billing_details",
      //       "args": "uhId:" + bedData.uhId + ",admissionId:" + (bedData.encounter_id ? bedData.encounter_id : bedData.admissionId),
      //       "query_id": "GET_BY_ADMISSION_ID"
      //     }
      //   }
      // }
      this._currentData.showBanner = true;
    }
    if (resouceDef.conditionVisible != undefined) {
      this._currentData.conditionVisibleTab = resouceDef.conditionVisible;
    }
    if (resouceDef.layout != undefined && resouceDef.layout.length) {
      resouceDef.layout = this.rolePermissionService.getAllowedTabs(resouceDef.layout);
      if (resouceDef.default_layout_id == undefined && resouceDef.layout && resouceDef.layout.length > 0)
        this._layout_id = resouceDef.layout[0].id;
      let allPromiseObj: any = [];
      var defaultLayoutFound = false;
      for (const layout of resouceDef.layout) {
        if (resouceDef.default_layout_id != undefined && resouceDef.default_layout_id == layout.id) {
          defaultLayoutFound = true;
        }
        this._layout_data[layout.id] = {};
        this._layout_data[layout.id]['data'] = layout;
        allPromiseObj.push(this.asyncProcess(layout));
      }
      if (resouceDef.default_layout_id != undefined && !defaultLayoutFound && resouceDef.layout.length > 0) {
        this._layout_id = resouceDef.layout[0].id;
      }
      //Checking if all resource json are loaded.
      Promise.all(allPromiseObj).then(() => {
        console.log("Layout Data ", this._layout_data);
        //If no permission redirect to 404
        if (Object.keys(this._layout_data).length > 0)
          this.initLayoutData();
        else
          this.router.navigate(['404'], { skipLocationChange: true });
      });
      // this._currentData.tabConfig = resouceDef.config;
    } else {
      alert("ERROR PLEASE FIX");
    }
  }
  refreshBanner() {
    if (this._currentData.showBanner) {
      this._currentData.bannerJson.existing_data = this._currentData.bannerJson.key;
      delete this._currentData.bannerJson.key;
      this._currentData.showBanner = false;
      setTimeout(() => {
        this._currentData.showBanner = true;
      })
    }
    // if (this.actTab == undefined || this.actTab == "billingSummary" || this.actTab == "billing_details" || this.actTab == "cancel_services") {
    //   if (this._currentData.bannerJson.existing_data && this._currentData.bannerJson.existing_data.is_addendum) {
    //     let refddata = {
    //       args: "admissionId:" + this._currentData.bannerJson.existing_data.admissionId + ",uhId:" + this._currentData.bannerJson.existing_data.uhId + ",addendum_bill_id:" + this._currentData.bannerJson.existing_data.addendum_bill_id,
    //       filter: "",
    //       page_size: 10,
    //       query_id: "GET_ADDENDUM_SUMMARY"
    //     }
    //     this.bindGridWithoutPrint(refddata, "", "addendum_billing_summary", "billing", "");
    //   } else {
    //     let refddata
    //     if (this.route.snapshot.queryParams.returnUrl.includes("ip_bed_format") || this.route.snapshot.queryParams.returnUrl.includes("bed_format") || this.route.snapshot.queryParams.returnUrl.includes("dc_bed_format")) {
    //       let bedData = JSON.parse(sessionStorage.getItem('bedManagementData'));
    //       refddata = {
    //         args: "uhId:" + bedData.uhId + ",admissionId:" + (bedData.encounter_id ? bedData.encounter_id : bedData.admissionId),
    //         filter: "",
    //         page_size: 10,
    //         query_id: "GET_BILLINGSUMMARY_PATIENT"
    //       }
    //     }
    //     else {
    //       refddata = {
    //         args: this._currentData.gridData.args != undefined ? this._currentData.gridData.args : "admissionId:" + this._currentData.bannerJson.existing_data.admissionId + ",uhId:" + this._currentData.bannerJson.existing_data.uhId,
    //         filter: "",
    //         page_size: 10,
    //         query_id: "GET_BILLINGSUMMARY_PATIENT"
    //       }
    //     }
    //     if (document.getElementById("billingSummary") != null && this.actTab != "cancel_services")
    //       document.getElementById("billingSummary").click();
    //     if (this.actTab == "cancel_services")
    //       document.getElementById("cancel_services").click();
    //     if (this.actTab != "cancel_services")
    //       this.bindGridWithoutPrint(refddata, "", "ip_billing_main_ip", "billing", "");
    //   }
    // }
  }
  ngOnDestroy() {
    // this.resetDublicasyHistory();
    this.communicationService.emitSidebar({ sidebar: true });
  }
}
